<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>

<div class="contact-container body-content-area">
    <div class="action-area">
        <div class="breadcrumb-area left-align">
            <p><a routerLink="/home"><u>Home</u> </a><span> > </span>
                <a routerLink="/home/fuel-escalator"><u>Fuel Escalator</u> </a><span> > </span>
                <span style="text-transform: capitalize;"> {{operation}} Fuel Escalator</span>
            </p>
        </div>
        <div class="header-area left-align btn-container">
            <span class="sub-title" style="text-transform: capitalize;">{{operation}} Fuel Escalator</span>
            <div class="action-bts">
                <button mat-button-primary class="btn white-red-btn" (click)="onbackCall()">Back</button>
                @if (operation!=='view') {
                    @if(operation ==="edit" && dataPriceSource?.Status !== "Calculated"){
                        <button mat-button-primary class="btn white-red-btn" [ngClass]="(escalatorForm.invalid && contactTableForm.invalid)?'disable-btn':'enable-btn'" (click)="onDelete()">Delete</button>
                    }
                    @if(dataPriceSource?.Status !== "Calculated"){
                        <button mat-button-primary class="btn red-white-btn" [ngClass]="(escalatorForm.valid && dataSource.data.length>0 )?'enable-btn':'disable-btn'" (click)="onSave()">Save</button>
                    }
                    @if(operation ==="edit" && dataPriceSource?.Status !== "Calculated"){
                    <button mat-button-primary class="btn red-white-btn" [ngClass]="((escalatorForm.invalid && contactTableForm.invalid) || dataPriceSource?.Status === 'Calculated')?'disable-btn':'enable-btn'" (click)="onUpdateRate()">Update Rate Agreements</button>
                    }
                }
            </div>
        </div>
    </div>

    <div class="agreement-form-area body-data">
        <div class="agreement-area">
            <form class="form" [formGroup]="escalatorForm">
                <table class="form-container" cellspacing="0">
                    <tr>
                        <div class="title" style="display: flex;width: fit-content;">Fuel Escalator Details
                            <ng-container *ngIf="operation !== 'add'">
                                <button *ngIf="dataPriceSource?.Status === 'Calculated'" class="btn green-white-btn" >Calculated</button>
                                <button  *ngIf="dataPriceSource?.Status !== 'Calculated'" class="btn amber-white-btn" >In Progress</button>    
                            </ng-container>
                        </div>
                    </tr>
                    <tr class="accord-area">
                        <div class="input-item items-2">
                            <label for='description' class='required-icon innerLabel'>Fuel Escalator Description</label>
                            <input type='text' name="description" formControlName="description" size='50'
                                placeholder="Enter Description" tabindex="1"/>
                        </div>

                        <div class="input-item items-2" style="position:relative; top:-4px;"  [ngClass]="this.operation === 'add'?'enable-field':'disable-field'" (keydown)="onKeyDown($event, this.operation === 'add')">
                            <label for='effectiveDate' class='required-icon innerLabel' style="margin-top: 6px;">Fuel Escalator Effective Date</label>
                                <!-- <input matInput  type="text" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px;cursor: pointer;"
                                date-date-format="DD/MM/YYYY" class="form-field custom-date"
                                bsDatepicker
                                formControlName="effectiveDate" (keydown)="onKeyDown($event)" [minDate]="minDate"
                                [bsConfig]="tableService.bsConfig" (bsValueChange)="onDaetChange($event,'effectiveDate')"
                                placeholder="DD/MM/YYYY"
                                > -->

                                <input type="text" matInput class="form-field dateFilter custom-date" placeholder="DD/MM/YYYY" style="font-size: 16px;text-transform: uppercase; padding-left: 15px;padding-top:15px;cursor: pointer;" readonly  
                                name="effectiveDate" [tabindex]="operation === 'add' ? 1 : -1"  formControlName="effectiveDate"  [matDatepicker]="initiatepicker"  [min]="minDate"  (click)="tableService.matDatePicker(initiatepicker,'effectiveDate')" (dateChange)="onDaetChange($event, 'effectiveDate')"/> 
                                <mat-datepicker #initiatepicker></mat-datepicker>
                        </div>

                        <div class="input-item disable-field">
                            <label for='createdDate' class='innerLabel'>Created (Date/Time)</label>
                            <input type="text" name="createdDate" formControlName="createdDate" size='50'
                                placeholder="Enter Created (Date/Time)" (keydown)="onKeyDown($event)" tabindex="-1"/>
                        </div>

                        <div class="input-item disable-field" (keydown)="onKeyDown($event)">
                            <label for='createdBy' class='innerLabel'>Created By</label>
                            <input type='text' name="createdBy" formControlName="createdBy" size='50'
                                placeholder="Enter Created By" tabindex="-1"/>
                        </div>

                        <div class="input-item disable-field" >
                            <label for='modifiedDate' class='innerLabel'>Modified (Date/Time)</label>
                            <input type="text" name="modifiedDate" formControlName="modifiedDate" size='50'
                                placeholder="Enter Modified (Date/Time)" (keydown)="onKeyDown($event)"tabindex="-1"/>
                        </div>

                        <div class="input-item disable-field" (keydown)="onKeyDown($event)">
                            <label for='modifiedBy' class='innerLabel'>Modified By</label>
                            <input type='text' name="modifiedBy" formControlName="modifiedBy" size='50'
                                placeholder="Enter Modified By" tabindex="-1"/>
                        </div>
                    </tr>
                </table>
            </form>
        </div>
    </div>
    <div class="form-container" cellspacing="0">
        <div style="display: flex;justify-content: space-between;">
            <div class="title" style="display: flex;width: fit-content;">Index for Fuel Price</div>
            <div class="btn-right-area" *ngIf="dataPriceSource?.Status !== 'Calculated'" style="display: inline-flex;align-items: center;margin-right: 10px;">
                @if(operation !== 'view'){
                <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px" [ngClass]="{'clickable': tableService.disablingDownload(this), 'non-clickable': !tableService.disablingDownload(this)}"
                    (click)="onDeleteRow()"><mat-icon>delete</mat-icon><span>Delete Row</span> </button>
                <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px"
                    (click)="onAddNewRow()"><mat-icon>add</mat-icon><span>Add New Row</span></button>
                <img (click)="onImportData()" class="download-icon icons" style="transform: rotate(180deg);"
                    src="../../../../assets/images/download-icon.png" alt="Profile Picture">
                
                }
                <img (click)="onExportdata()" *ngIf="operation !='add'" class="download-icon icons" [ngClass]="{'clickable': tableService.disablingDownload(this), 'non-clickable': !tableService.disablingDownload(this)}"
                    src="../../../../assets/images/download-icon.png" alt="Profile Picture">
            </div>
        </div>
        <div class="mat-table-area">
            <hr style="width: 100%;">
             <table mat-table [dataSource]="dataSource" [ngStyle]="(operation === 'view' || dataPriceSource?.Status === 'Calculated') ? { 'pointer-events': 'none', 'opacity':0.7 }:{'pointer-events': 'auto','opacity':1}" 
             [formGroup]="contactTableForm" matSort (matSortChange)="tableService.announceSortChange(this,$event,'')" class="mat-elevation-z8">

            @for (i of displayedColumns; track i; let ind=$index) {
                @if (i.name === 'Selected') {
                <ng-container matColumnDef='Selected'>
                    <th mat-header-cell *matHeaderCellDef style="width: 3%;pointer-events: all;" (keydown)="onKeyDownOnTable($event)">
                        <div style="display: inline-flex;">
                            <input type="checkbox" id="all" name="all" style="left: 3px;"[checked]="allSelected"
                                (change)="tableService.selectAllItem(this)">
                        </div>

                    </th>
                    <td mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)">
                        <div style="display: inline-flex;box-sizing: content-box;pointer-events: all;">
                            <input type="checkbox" id={{element.CountryID}} name={{element.CountryID}} [checked]="element.Selected"
                            (change)="tableService.selectItem(ind,this,'fuel-price')">
                        </div>
                    </td>
                </ng-container>
                }
                @else if(i.name === 'CountryofFuelIndex'){
                    <ng-container matColumnDef='CountryofFuelIndex'>
                        <th mat-header-cell class="scrollable" *matHeaderCellDef (keydown)="onKeyDownOnTable($event)">
                            <div mat-sort-header class="country-header">{{i.label}} <span class="required-icon"></span></div>
                            <div class="origin">
                                <input matInput class="form-field" [formControlName]="'CountryofFuelIndexFilter'"
                                    placeholder="Filter">

                            </div>
                        </th>
                        <td class="scrollable country-item" mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)"> 
                            <!-- @if(element['CountryID']===0){ -->
                                <select required (change)="onCheckValue($event.target,i.name, ind, element)" >
                                    <option *ngIf="element['CountryID']===0">Choose</option>
                                    <option *ngFor="let option of countryListArr" [value]="option.CountryID" [selected]="(element['CountryID'] === option.CountryID)">
                                        {{ option.CountryName }}
                                    </option>                                            
                                </select>
                                
                            <!-- }
                            @else {
                                <span>{{findCountryName(element['CountryID'])}}</span>
                            } -->
                        </td>
                    </ng-container>
                    }
                @else if(i.name === 'IncludeTax'){
                    <ng-container matColumnDef='IncludeTax'>
                        <th mat-header-cell class="scrollable" *matHeaderCellDef (keydown)="onKeyDownOnTable($event)">
                            <div mat-sort-header class="country-header">{{i.label}} <span class="required-icon"></span></div>
                            <div class="origin">
                                <input matInput class="form-field" [formControlName]="'IncludeTaxFilter'"
                                    placeholder="Filter">

                            </div>
                        </th>
                        <td class="scrollable country-item" mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)"> 
                            <select required (change)="onCheckValue($event.target,i.name, ind, element)" >
                                <option *ngFor="let option of ['Yes','No']" [value]="option" [selected]="(element['IncludeTax']) ===option">
                                    {{ option }}
                                </option>                                            
                            </select>
                        </td>
                    </ng-container>
                    }

                @else{
                <ng-container matColumnDef={{i.name}}>
                    <th mat-header-cell class="scrollable" *matHeaderCellDef (keydown)="onKeyDownOnTable($event)">
                        <div mat-sort-header><span class="required-icon">{{i.label}}</span></div>
                        <div class="origin">
                            <input matInput class="form-field" [formControlName]="'EscalatorValueFilter'"
                                placeholder="Filter">
                        </div>
                    </th>
                    <td class="scrollable" mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)">
                        <input matInput class="form-field" (change)="onCheckValue($event.target,i.name, ind, element)" value="{{element[i.name]}}"
                        type="number" placeholder=""> 
                    </td>
                </ng-container>
                }
            }
            <tr mat-header-row *matHeaderRowDef="dataColList"></tr>
            <tr mat-row *matRowDef="let row; columns: dataColList;"></tr>
        </table> 
        <hr style="width: 100%;">

        <div class="table-footer">
            <!-- <span style="color: #666666; font-size: 12px;">(Showing {{getCurrentRecordCount()}} out of {{ dataSource.data.length }}
                results)</span> -->
            <div style="display: flex;">
                <mat-paginator [pageSizeOptions]="[1, 5, 10, 20]" [pageSize]="pageSize" [length]="totalRecord"
                    (page)="tableService.onPageChange($event,this,'editfuelEsltr')" showFirstLastButtons aria-label="Select page of periodic elements">
                </mat-paginator>
                <div class="gotoArea">
                    <span style="color: #666666;">Go to page</span>
                    <input type="number"
                        style="width: 40px;padding: 0px;text-align: center;font-size: 14px;color: #666666;"
                        [(ngModel)]="goToPageNumber">
                        <div style="font-weight:500; margin-right:4px"> / {{getPageCount()}}</div>
                    <button style="min-width: 40px;font-weight: 900;" class="white-red-btn"
                        (click)="tableService.goToPage(this)">Go</button>
                </div>
            </div>

        </div>

    </div>
</div>